<div class="pagination-container" (click)="pageChange(2)">
    <div *ngFor="let item of [].constructor(pages);let p = index;" [ngClass]="isSelected(p+1)">
        {{p+1}}
    </div>
</div>